<template>
  <div class="add-visit-person">
    <title-bar
      :title="
        isEdit
          ? $t('Gattaran_0_Edit_contacts_nCLZ' /** 编辑联系人 */)
          : $t('Gattaran_0_Create_new_Faau' /** 新建联系人 */)
      "
      show-back
      @back="back"
    />
    <div class="add-visit-person-list-wrapper">
      <soda-form
        v-if="dataLoaded"
        ref="form"
        v-model="formData"
        class="add-visit-person-form"
        :config="formConfig"
      />
    </div>
    <div class="save">
      <rich-button class="save-btn" :loading="loading" @click="save">
        <span>{{ gettext('保存') }}</span>
      </rich-button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import TitleBar from '@/components/TitleBar'
import SodaForm from '@/components/form/index'
import { mapState } from 'vuex'
import { getVisitObjectInit, saveVisitObject } from '@/api'
import daphne from '@didi/daphne-sdk-javascript'
import ruleConfig from '@/common/utils/rules-COM'
import { i18n, sprintf, getBDCountry } from '@/common/utils/i18n'
const nI18n = {
  gettext: i18n.gettext,
  sprintf
}
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
export default {
  name: 'AddVisitPerson',
  components: {
    TitleBar,
    SodaForm
  },
  props: {
    roleId: {
      required: false,
      type: Number
    },
    contactId: {
      required: false,
      type: Number
    },
    isEdit: {
      required: true,
      type: Boolean
    },
    options: {}
  },
  data () {
    const country = getBDCountry() || 'MX'
    return {
      loading: false,
      dataLoaded: false,
      shopId: this.$route.query.shopId,
      formData: {
        roleId: null,
        contactId: null,
        name: '',
        phone: '',
        mail: '',
        whatsappPhone: '',
        contactTime: ['', ''],
        contactMode: []
      },
      visitObjectList: [],
      phonePreText: '',
      country,
    }
  },
  computed: {
    ...mapState(['login']),
    roleList () {
      const list = this.options.roleId?.enum
      return list.length > 0
        ? list.map(i => ({ value: i.value, text: i.label }))
        : []
    },
    contactModeList () {
      return this.options.contactMode.enum
    },
    formConfig () {
      const emailRule = ruleConfig.email('', nI18n)
      const phoneRule = ruleConfig.telePhone('', nI18n)
      if (this.country === 'BR') {
        return [
          {
            label: this.$t('Gattaran_0_Role_QDBu' /** 角色 */),
            type: 'rich-select',
            prop: 'roleId',
            props: {
              disabled: this.isEdit,
              options: this.availableRoleList,
              placeholder: this.gettext('请选择')
            },
            rules: {
              required: true
            }
          },
          {
            label: this.gettext('姓名'),
            type: 'input',
            prop: 'name',
            props: {
              placeholder: this.gettext('请输入')
            },
            rules: {
              required: true
            }
          },
          {
            label: this.gettext('电话'),
            type: 'phone',
            prop: 'phone',
            props: {
              placeholder: this.gettext('请输入'),
              preText: this.phonePreText
            },
            rules: {
              ...phoneRule.rules,
              required: true,
              type: 'number'
            },
            messages: phoneRule.messages
          },
          {
            label: this.$t('FoodB_email_CBNM_cSdr' /** 邮箱 */),
            type: 'input',
            prop: 'mail',
            props: {
              placeholder: this.gettext('请输入')
            },
            rules: {
              // type: 'email',
              ...emailRule.rules
            },
            messages: emailRule.messages
          },
          {
            label: this.$t('FoodB_leads_The_relationship_jkYA' /** 倾向联系时间 */),
            type: 'timeRangePicker',
            prop: 'contactTime',
            props: {
              placeholder: this.gettext('请选择')
            },
            rules: {
              custom: (val) => {
                if (!val[0] || !val[1]) {
                  return true
                } else {
                  const start = +new Date(`1970/01/01 ${val[0]}`)
                  const end = +new Date(`1970/01/01 ${val[1]}`)
                  return start < end
                }
              }
            },
            messages: {
              custom: this.$t('Gattaran_0_The_end_KvBf' /** 结束时间必须大于开始时间 */)
            }
          },
          {
            label: this.$t('FoodB_optimization_Stimulate_contact_xSSH' /** 倾向联系方式  */),
            type: 'multiSelectNew',
            prop: 'contactMode',
            props: {
              options: this.contactModeList,
              placeholder: this.gettext('请选择')
            }
          }
        ]
      } else {
        return [
          {
            label: this.$t('Gattaran_0_Role_QDBu' /** 角色 */),
            type: 'rich-select',
            prop: 'roleId',
            props: {
              disabled: this.isEdit,
              options: this.availableRoleList,
              placeholder: this.gettext('请选择')
            },
            rules: {
              required: true
            }
          },
          {
            label: this.gettext('姓名'),
            type: 'input',
            prop: 'name',
            props: {
              placeholder: this.gettext('请输入')
            },
            rules: {
              required: true
            }
          },
          {
            label: this.$t('FoodB_optimization_Stimulate_contact_xSSH' /** 倾向联系方式  */),
            type: 'multiSelectNew',
            prop: 'contactMode',
            props: {
              options: this.contactModeList,
              placeholder: this.gettext('请选择')
            },
            rules: {
              required: true
            }
          },
          {
            label: this.gettext('电话'),
            type: 'phone',
            prop: 'phone',
            props: {
              placeholder: this.gettext('请输入'),
              preText: this.phonePreText
            },
            rules: {
              ...phoneRule.rules,
              required: this.formData?.contactMode?.includes(1) || this.formData?.contactMode?.includes(5),
              type: 'number'
            },
            messages: phoneRule.messages
          },
          {
            label: this.$t('FoodB_email_CBNM_cSdr' /** 邮箱 */),
            type: 'input',
            prop: 'mail',
            props: {
              placeholder: this.gettext('请输入')
            },
            rules: {
              // type: 'email',
              ...emailRule.rules,
              required: this.formData?.contactMode?.includes(3),
            },
            messages: emailRule.messages
          },
          {
            label: this.$t('FoodB_20250612_vHLr_wHDi' /** WhatsApp号码 */),
            type: 'phone',
            prop: 'whatsappPhone',
            props: {
              placeholder: this.gettext('请输入'),
              preText: this.phonePreText
            },
            rules: {
              ...phoneRule.rules,
              required: this.formData?.contactMode?.includes(2),
              type: 'number'
            },
            messages: phoneRule.messages
          },
          {
            label: this.$t('FoodB_leads_The_relationship_jkYA' /** 倾向联系时间 */),
            type: 'timeRangePicker',
            prop: 'contactTime',
            props: {
              placeholder: this.gettext('请选择')
            },
            rules: {
              custom: (val) => {
                if (!Array.isArray(val) || !val[0] || !val[1]) {
                  return false
                } else {
                  const start = +new Date(`1970/01/01 ${val[0]}`)
                  const end = +new Date(`1970/01/01 ${val[1]}`)
                  return start < end
                }
              },
              required: true
            },
            messages: {
              custom: this.$t('Gattaran_0_The_end_KvBf' /** 结束时间必须大于开始时间 */)
            }
          },
        ]
      }
    },
    availableRoleList () {
      const existedRoleIds = this.visitObjectList.map(i => i.roleId)

      // 统计各角色类型数量
      const operatorCount = this.visitObjectList.filter(i => i.roleId === 2).length
      const shopStaffCount = this.visitObjectList.filter(i => i.roleId === 3).length
      const KPFriendsFamilyCount = this.visitObjectList.filter(i => i.roleId === 5).length
      const otherRoleCount = this.visitObjectList.filter(i => i.roleId === 6).length

      return this.isEdit
        ? this.roleList
        : this.roleList.filter(role => {
            // 决策人限制 & 经理限制
            if (existedRoleIds.includes(role.value) && (role.value === 1 || role.value === 4)) return false

            // 操作员数量限制
            if (role.value === 2 && operatorCount >= 10) return false

            // 店员数量限制
            if (role.value === 3 && shopStaffCount >= 10) return false

            // 朋友/家人数量限制
            if (role.value === 5 && KPFriendsFamilyCount >= 10) return false

            // 其他角色数量限制
            if (role.value === 6 && otherRoleCount >= 10) return false

            return true
          })
    }
  },
  async mounted () {
    const loading = this.$createToast({ mask: true })
    loading.show()
    // 获取callingCode配置
    const { country } = this.login.userInfo
    const callingCode = daphne.getCallingCode(country)
    this.phonePreText = callingCode

    // 获取拜访相关配置
    const initConf = await getVisitObjectInit({ shopId: this.shopId })
    this.visitObjectList = initConf.visitObjectList || []

    // 编辑页获取拜访详情回显表单
    if (this.isEdit) {
      const contactDetail = this.visitObjectList.find(i => i.contactId === this.contactId && i.roleId === this.roleId)
      const { name, phone, mail, contactTime = [], contactMode = [], roleId, contactId, whatsappPhone } = contactDetail

      this.formData.roleId = roleId
      this.formData.contactId = contactId
      this.formData.name = name
      this.formData.phone = phone
      this.formData.mail = mail
      this.formData.whatsappPhone = whatsappPhone
      this.formData.contactTime = contactTime && contactTime.length
                                    ? [contactTime[0].startTime, contactTime[0].endTime]
                                    : ['', '']
      this.formData.contactMode = contactMode.map(i => i.key)
    }

    this.dataLoaded = true
    loading.hide()
  },
  methods: {
    async save () {
      const isValid = await this.$refs.form.validate()
      if (isValid) {
        this.loading = true
        const { shopId } = this
        const { name, phone, mail, whatsappPhone, contactTime = ['', ''], contactMode = [], roleId, contactId } = this.formData
        const selectedRole = this.roleList.find(role => role.value === roleId) || {}
        const roleDesc = selectedRole.text
        const params = {
          shopId,
          roleId,
          roleDesc,
          name,
          phone,
          mail,
          whatsappPhone,
          contactId,
          contactTime: [{
            startTime: contactTime ? contactTime[0] : '',
            endTime: contactTime ? contactTime[1] : ''
          }],
          contactMode
        }
        const res = await saveVisitObject(params)
        this.loading = false
        if (res) {
          this.$emit('save', params)
          this.$emit('back')
        }
      }
    },
    back () {
      this.$emit('back')
    },
  }
}
</script>

<style lang="scss" scoped>
.add-visit-person {
  position: relative;
  background-color: #f2f3f6;
  height: 100%;

  .notification {
    display: flex;
    align-items: center;
    width: 100%;
    background: #e9eaee;
    z-index: 1;
    text-align: left;

    p {
      flex: 1;
      padding: 24px 0 24px 40px;
      font-size: 24px;
      color: #595c66;
      line-height: 32px;
      font-weight: 400;

      .icon-outlined_information {
        margin-right: 6px;
        font-size: 32px;
        vertical-align: middle;
      }
    }

    .richic-close {
      display: flex;
      align-items: center;
      margin: 0 32px;
      flex: 0;
      font-size: 48px;
    }
  }

  &-list-wrapper {
    padding-bottom: 120px;
    background-color: #f2f3f6;
    height: calc(100vh - 100px - 152px);
    box-sizing: border-box;
    overflow: scroll;
  }

  &-form {
    margin: 24px;
    box-sizing: border-box;
    border-radius: 16px;
    background-color: #ffffff;
    ::v-deep #contactTime {
      padding-bottom: 16px;
    }
    ::v-deep .rich-form-item {
      padding: 24px;

      .rich-form-label {
        font-size: 24px;
        color: #8d9099;
        line-height: 32px;
        padding-bottom: 16px;
      }
      .rich-form-field {
        font-family: DiDiSans-Pro-Medium;
        font-size: 36px;
        color: #282b33;
        line-height: 44px;
        padding-bottom: 16px;

        .rich-input-wrapper {
          height: auto;
          .rich-input-label-placeholder {
            display: none;
          }
          .rich-input-bottom {
            padding: 0;
          }
        }
      }
    }
  }

  .save {
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #ffffff;
    padding: 20px 24px 40px 24px;
    box-sizing: border-box;
    &-btn {
      font-family: DiDiSans-Pro-Bold;
      font-size: 32px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
    }
  }
}
</style>
